export default __webpack_public_path__ + "static/media/microscope.39c1290c.png";